module.exports = __webpack_public_path__ + "img/claw-marks.49393353.svg";